<template>
  <div v-loading="loading">
    <div class="title">项目预览</div>
    <div class="project-container">
      <div
        class="tree-container"
        :style="{ width: treeWidth, paddingRight: treePaddingRight }"
      >
        <el-tree
          :data="treeData"
          :props="treeProps"
          node-key="id"
          :indent="0"
          :highlight-current="true"
          default-expand-all
          :expand-on-click-node="false"
          @node-click="handleNodeClick"
        >
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span class="tree-label">{{ data.name }}</span>
          </span>
        </el-tree>
      </div>
      <div class="content-container" :style="{ borderLeft: contentBorderLeft }">
        <div
          class="fold-icon-wrapper"
          :class="{ fold: collapse }"
          @click="handleCollapse"
        >
          <zhu-svg svg-class="fold-icon" svg-name="fold"></zhu-svg>
        </div>
        <div class="content-title">
          <div v-show="type === 'base'">
            <el-divider>基本设置</el-divider>
          </div>
          <div v-show="type === 'detail'">
            <el-divider>{{ detail.name }}</el-divider>
          </div>
        </div>
        <div class="content-info">
          <div class="basic-info" v-show="type === 'base'">
            <div class="basic-info-">
              <el-form label-width="110px" :model="treeData[0]">
                <el-form-item label="项目名称：">
                  <el-input
                    class="w-400"
                    v-model="treeData[0].name"
                    size="small"
                    disabled
                  ></el-input>
                </el-form-item>
                <el-form-item label="项目介绍：">
                  <el-input
                    class="w-400"
                    v-model="treeData[0].description"
                    size="small"
                    type="textarea"
                    :autosize="{ minRows: 2, maxRows: 5 }"
                    resize="none"
                    disabled
                  ></el-input>
                </el-form-item>
                <el-form-item label="教学目标：">
                  <el-input
                    class="w-400"
                    v-model="treeData[0].teaching_aim"
                    size="small"
                    type="textarea"
                    :autosize="{ minRows: 2, maxRows: 5 }"
                    resize="none"
                    disabled
                  ></el-input>
                </el-form-item>
                <el-form-item label="职业方向：">
                  <el-input
                    v-if="treeData[0].job_name"
                    class="w-400"
                    v-model="treeData[0].job_name"
                    size="small"
                    disabled
                  ></el-input>
                </el-form-item>
                <el-form-item label="项目难度：">
                  <el-input
                    class="w-400"
                    v-model="treeData[0].difficult_level_label"
                    size="small"
                    disabled
                  ></el-input>
                </el-form-item>
                <el-form-item label="项目学习时长：">
                  <el-input
                    class="w-400"
                    v-model="treeData[0].duration"
                    size="small"
                    disabled
                  >
                  </el-input>
                </el-form-item>
                <el-form-item label="技能点：">
                  <el-input
                    class="w-400"
                    v-model="treeData[0].skill"
                    size="small"
                    type="textarea"
                    :autosize="{ minRows: 2, maxRows: 5 }"
                    resize="none"
                    disabled
                  ></el-input>
                </el-form-item>
                <el-form-item label="能力目标：">
                  <el-input
                    class="w-400"
                    v-model="treeData[0].ability_aim"
                    size="small"
                    type="textarea"
                    :autosize="{ minRows: 2, maxRows: 5 }"
                    resize="none"
                    disabled
                  ></el-input>
                </el-form-item>
                <el-form-item label="项目配图：">
                  <span
                    class="project-img-none normal-info-color"
                    v-if="!treeData[0].cover_file"
                    >暂无</span
                  >
                  <span v-else class="project-img">
                    <img :src="treeData[0].cover_file.path" />
                  </span>
                </el-form-item>
              </el-form>
            </div>
          </div>
          <div class="detail-info" v-show="type === 'detail'">
            <div
              class="detail-info-item"
              v-for="item in detail.contents"
              :key="item.id"
            >
              <template v-if="item.type === 'text'">
                <div class="md">
                  <markdown-it :md="item.content.html"></markdown-it>
                </div>
              </template>

              <template v-if="item.type === 'question'">
                <el-card shadow="hover" class="qa">
                  <el-link
                    v-show="QAMode !== 'preview'"
                    class="qa-refresh"
                    icon="el-icon-refresh-left"
                    :underline="false"
                    @click="QAMode = 'preview'"
                  ></el-link>
                  <div v-show="QAMode === 'preview'">
                    <el-divider class="qa-name">{{
                      item.content.title
                    }}</el-divider>
                    <div class="qa-description info-color">
                      {{ item.content.desc }}
                    </div>
                    <div class="qa-content-list">
                      <span
                        v-for="(data, index) in item.content.button"
                        :key="index"
                      >
                        <el-button
                          class="qa-btn"
                          :type="
                            item.content.mainButton === index ? 'primary' : ''
                          "
                          @click="showQAResult(data)"
                        >
                          {{ data.text }}
                        </el-button>
                      </span>
                    </div>
                  </div>
                  <div v-show="QAMode === 'result'">
                    <el-divider class="qa-name">
                      <img
                        class="qa-img"
                        :src="QAResult.icon"
                        v-if="QAResult.icon"
                      />
                      <span>{{ QAResult.title }}</span>
                    </el-divider>
                    <div
                      class="qa-description info-color"
                      style="margin-top: 20px"
                    >
                      {{ QAResult.desc }}
                    </div>
                  </div>
                </el-card>
              </template>

              <template v-if="item.type === 'evaluate'">
                <el-card shadow="hover" class="review">
                  <el-link
                    v-show="reviewMode !== 'preview'"
                    class="review-refresh"
                    icon="el-icon-refresh-left"
                    :underline="false"
                    @click="refreshReview"
                  ></el-link>
                  <div v-show="reviewMode === 'preview'">
                    <el-divider class="review-name">{{
                      item.content.title
                    }}</el-divider>
                    <div class="review-description info-color">
                      {{ item.content.desc }}
                    </div>
                    <div class="review-content-list">
                      <div
                        class="review-content-item"
                        v-for="(data, index) in item.content.commentArr"
                        :key="index"
                        @click="showReviewDialogs(data)"
                      >
                        <img :src="data.icon" />
                        <span>{{ data.text }}</span>
                      </div>
                    </div>
                  </div>
                  <div v-show="reviewMode === 'select'">
                    <el-divider class="review-name">{{
                      reviewSelectTitle
                    }}</el-divider>
                    <el-checkbox-group
                      v-model="reviewSelectList"
                      class="review-select-list"
                    >
                      <el-checkbox
                        class="review-select-item"
                        v-for="(data, index) in reviewSelectArr"
                        :key="index"
                        :label="data"
                      ></el-checkbox>
                    </el-checkbox-group>
                    <div>
                      <el-button
                        class="review-btn"
                        size="mini"
                        @click="reviewMode = 'result'"
                        >提交</el-button
                      >
                    </div>
                  </div>
                  <div v-show="reviewMode === 'result'">
                    <el-divider class="review-name">{{
                      item.content.title
                    }}</el-divider>
                    <div class="review-result">
                      <img :src="reviewResult.icon" />
                      <span>{{ reviewResult.text }}</span>
                    </div>
                  </div>
                </el-card>
              </template>

              <template v-if="item.type === 'punch_card'">
                <el-card shadow="hover" class="clock-in">
                  <el-divider class="clock-in-title">{{
                    item.content.title
                  }}</el-divider>
                  <div class="clock-in-description info-color">
                    {{ item.content.description }}
                  </div>
                  <el-input
                    style="width: 70%"
                    size="small"
                    type="textarea"
                    :rows="4"
                    resize="none"
                    placeholder="快快输入你的学习感悟吧～"
                    disabled
                  ></el-input>
                </el-card>
              </template>

              <template v-if="item.type === 'homework'">
                <img src="@/assets/images/project.png" width="100%" />
              </template>

              <template v-if="item.type === 'graduation_work'">
                <img src="@/assets/images/design.png" width="100%" />
              </template>

              <template v-if="item.type === 'certificate'">
                <img src="@/assets/images/diploma.jpg" width="100%" />
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MarkdownIt from "@jiker/markdown-it/MarkdownIt.vue";
import studentService from "@/global/service/student";

export default {
  components: {
    MarkdownIt
  },
  data() {
    return {
      loading: true,
      collapse: false,
      treeData: [{}],
      treeProps: {
        label: "name",
        children: "pages"
      },
      type: "base",
      detail: {
        name: "",
        contents: []
      },
      QAMode: "preview",
      QAResult: {
        title: "",
        icon: "",
        desc: ""
      },
      reviewMode: "preview",
      reviewSelectTitle: "",
      reviewSelectArr: [],
      reviewSelectList: [],
      reviewResult: {
        text: "",
        icon: ""
      }
    };
  },
  computed: {
    treeWidth() {
      return this.collapse ? 0 : "200px";
    },
    treePaddingRight() {
      return this.collapse ? 0 : "30px";
    },
    contentBorderLeft() {
      return this.collapse ? "none" : "1px solid #e9eaf2";
    }
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      const id = this.$route.params.id;
      studentService
        .projectShow(id)
        .then(res => {
          this.treeData = [{}];
          res.duration = res.duration + " 小时";
          res.job_name = res.job_name ? res.job_name : "暂无";
          res.difficult_level_label = res.difficult_level_label
            ? res.difficult_level_label
            : "暂无";
          this.treeData[0] = res;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleNodeClick(data) {
      if (data.pages) {
        this.type = "base";
        this.detail.name = "";
        this.detail.contents = [];
        return;
      } else {
        this.type = "detail";
        this.detail.name = data.name;
        this.detail.contents = data.contents;
      }
    },
    showQAResult(data) {
      this.QAMode = "result";
      this.QAResult.title = data.title;
      this.QAResult.icon = data.icon;
      this.QAResult.desc = data.desc;
    },
    refreshReview() {
      this.reviewMode = "preview";
      this.reviewSelectList = [];
    },
    showReviewDialogs(data) {
      this.reviewMode = "select";
      this.reviewSelectTitle = data.dialogTitle;
      this.reviewSelectArr = data.optionArr.filter(item => item);
      this.reviewResult.text = data.text;
      this.reviewResult.icon = data.icon;
    },
    handleCollapse() {
      this.collapse = !this.collapse;
    }
  }
};
</script>

<style lang="less" scoped>
.title {
  margin-bottom: 12px;
}
.project-container {
  display: flex;
  .tree-container {
    padding-top: 12px;
    min-height: 500px;
    transition: all 0.2s ease-out;
    overflow: hidden;
    .tree-label {
      display: inline-block;
      width: 140px;
      font-size: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .content-container {
    position: relative;
    flex: 1;
    padding-left: 30px;
    min-width: 740px;
    .fold-icon-wrapper {
      position: absolute;
      top: 22px;
      left: -20px;
      z-index: 1;
      width: 20px;
      height: 32px;
      line-height: 30px;
      text-align: center;
      border: 1px solid #dee0e3;
      border-radius: 4px;
      background-color: #fff;
      border-right: none;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      transition: all 0.2s ease-out;
      cursor: pointer;
      &.fold {
        left: -30px;
        transform: rotate(180deg);
      }
      .fold-icon {
        color: #656a72;
        &:hover {
          color: #409eff;
        }
      }
    }
    .content-info {
      .basic-info {
        margin-top: 48px;
        text-align: center;
        .basic-info- {
          display: inline-block;
          width: 510px;
        }
        .project-img {
          display: inline-block;
          width: 100%;
          text-align: left;
          img {
            width: 140px;
            height: 140px;
          }
        }
        .project-img-none {
          display: inline-block;
          margin-left: 4px;
          width: 100%;
          text-align: left;
        }
      }
      .detail-info {
        margin-top: 36px;
        .detail-info-item {
          position: relative;
          margin-bottom: 24px;
          .md {
            text-align: left;
          }
          .clock-in {
            padding: 16px 0;
            width: 100%;
            text-align: center;
            .clock-in-title {
              display: inline-block;
              margin-bottom: 16px;
              width: 70%;
            }
            .clock-in-description {
              margin-bottom: 24px;
              font-size: 12px;
            }
          }
          .qa {
            padding: 16px 0;
            width: 100%;
            text-align: center;
            .qa-refresh {
              position: absolute;
              top: 16px;
              right: 16px;
              font-size: 16px;
            }
            .qa-name {
              display: inline-block;
              margin-bottom: 16px;
              width: 70%;
              .qa-img {
                margin-right: 8px;
                width: 30px;
                height: 30px;
                vertical-align: middle;
              }
              span {
                vertical-align: middle;
              }
            }
            .qa-description {
              margin-bottom: 24px;
              font-size: 12px;
            }
            .qa-btn {
              margin: 0 8px;
            }
          }
          .review {
            padding: 16px 0;
            width: 100%;
            text-align: center;
            .review-refresh {
              position: absolute;
              top: 16px;
              right: 16px;
              font-size: 16px;
            }
            .review-name {
              display: inline-block;
              margin-bottom: 16px;
              width: 70%;
            }
            .review-description {
              margin-bottom: 32px;
              font-size: 12px;
            }
            .review-content-list {
              display: flex;
              justify-content: center;
              .review-content-item {
                margin: 0 12px;
                cursor: pointer;
                &:hover {
                  opacity: 0.8;
                }
                img {
                  display: block;
                  margin: 0 auto 10px;
                  width: 36px;
                  height: 36px;
                }
                span {
                  display: inline-block;
                  max-width: 90px;
                  font-size: 14px;
                  vertical-align: middle;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                }
              }
            }
            .review-select-list {
              display: inline-block;
              padding-left: 5%;
              width: 40%;
              text-align: left;
              .review-select-item {
                margin-bottom: 8px;
                width: 100%;
              }
            }
            .review-btn {
              margin-top: 12px;
            }
            .review-result {
              margin-top: 12px;
              img {
                margin-right: 12px;
                width: 36px;
                height: 36px;
                vertical-align: middle;
              }
              span {
                vertical-align: middle;
              }
            }
          }
        }
      }
    }
  }
}
</style>
